/* eslint-disable import/order */
import React from 'react';
import { FaRegFileAlt } from 'react-icons/fa';
import { IoMdArrowBack } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { useEvieAppContext } from 'components/evieApp/EvieAppProvider';
import { useEvieHomeContext } from 'components/evieApp/EvieHomeProvider';
import { ROUTES } from 'utils/constants';
import { HOME_STATUS } from '../utils';

import SolidButton from 'components/SolidButton';
import ProgramContentCard from '../ProgramContentCard';

const ProgramInfo = () => {
  const { t } = useTranslation();
  const { push } = useHistory();
  const { program: { title = '', programLevels = [], backgroundImage: { original = '' } } = {} } = useEvieAppContext();
  const { changeHomeStatus } = useEvieHomeContext();

  return (
    <section className="program-info">
      <section className="program-info__topbar">
        <IoMdArrowBack onClick={() => changeHomeStatus(HOME_STATUS.IDLE)} />
      </section>
      <header className="program-info__header" style={{ backgroundImage: `url(${original})` }}>
        <div className="program-info__header_bg" />
        <div className="program-info__title">
          <div className="program-info__duration">
            <div className="program-info__duration_icon">
              <FaRegFileAlt />
            </div>
            <span>
              {programLevels.length} {t('evieApp.programInfo.units')}
            </span>
          </div>
          <h2>{title}</h2>
        </div>
      </header>
      <ProgramContentCard content="description" />
      <ProgramContentCard content="benefits" />
      <ProgramContentCard content="content" />
      <div className="program-info__startbtn">
        <SolidButton className="evie-survey" onClick={() => push(`${ROUTES.EVIE_ONBOARDING}?view=plans`)}>
          {t('evieApp.programInfo.startBtn')}
        </SolidButton>
      </div>
    </section>
  );
};

export default ProgramInfo;
